import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: any) => ({
  containerStyle: {
    position: "absolute",
    top: "0",
    left: "0",
    backgroundColor: theme?.palette?.customColor?.BGLIGHT,
    width: "100%",
    height: "100%",
    zIndex: "999",
  },
  logoDispaly: {
    [`@media (min-width:${theme?.breakpoints?.values?.sm}px)`]: {
      display: "none",
    },
    [`@media (min-width:${theme?.breakpoints?.values?.xs}px)`]: {
      display: "none",
    },
    [`@media (min-width:${theme?.breakpoints?.values?.md}px)`]: {
      display: "flex",
    },
    cursor: "pointer",
  },
  headerTextDispaly: {
    [`@media (min-width:${theme?.breakpoints?.values?.sm}px)`]: {
      display: "flex",
    },
    [`@media (min-width:${theme?.breakpoints?.values?.xs}px)`]: {
      display: "flex",
    },
    [`@media (min-width:${theme?.breakpoints?.values?.md}px)`]: {
      display: "none",
    },
  },
  createCoursetophead: {
    display: "flex",
    position: "sticky",
    top: 0,
    zIndex: 2,
    background: "#fff",
    borderBottom: "solid 1px #ced3d9",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 20px",
    minHeight: "62px",
  },

  contentStyle: {
    [`@media (min-width:${theme?.breakpoints?.values?.xs}px)`]: {
      paddingRight: "10px",
    },
    [`@media (min-width:${theme?.breakpoints?.values?.sm}px)`]: {
      paddingRight: "10px",
    },
    [`@media (min-width:${theme?.breakpoints?.values?.xs}px)`]: {
      paddingRight: "55px",
    },
    display: "flex",
    flexDirection: "row",
    background: theme?.palette?.customColor?.BGLIGHT,
    alignItems: "center",
    border: `1px solid ${theme?.palette?.customColor?.LINE}`,
    borderRadius: theme?.borderRadius?.value,
    // width: '389px',
    height: "50px",
    marginTop: "15px",
    position: "relative",
  },
  imgUploadBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5px 0px 0px 5px",
    width: "89px",
    height: "-webkit-fill-available",
    backgroundColor: theme?.palette?.customColor?.BGWEAK,
    cursor: "pointer",
  },

  heroBannerCloudIconBox: {
    width: "20px",
    height: "22px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  closeIconStyle: {
    position: "absolute",
    right: 0,
    padding: "5px 10px 5px 5px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  workflowIconContainer: {
    display: "flex",
    padding: "10px",
  },
  workflowIconActive: {
    filter: "brightness(0) invert(5%)",
    height: "16px",
  },
  workflowIconInactive: {
    filter: "brightness(0) invert(50%)",
    height: "16px",
  },
}));
